export default {
  title: 'Gå ikke glip af noget!',
  description: 'Slå notifikationer til for at holde dig opdateret om din bestilling.',
  buttons: {
    enable: 'Aktiver',
  },
};
